
// import { InvoiceFormData } from '@/types/appcontracts/InvoiceFormData'
import { InvoicesDocument } from '@/types/firebaseCollectionContracts/InvoicesDocument'
import { computed, createVNode, defineComponent, PropType, ref } from 'vue'
import InvoicePrintPage from './InvoicePrintPage.vue'
import * as actions from '@/store/actions.type'
import {
  EditOutlined,
  MailOutlined,
  ShareAltOutlined,
  BellOutlined,
  FilePdfOutlined,
  DollarOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue'
import { InvoiceStatusTypes } from '@/types/enums/InvoiceStatusTypes'
import { useStore } from 'vuex'
import { IAppDocument } from '@/types/interfaces/IAppDocument'
import { DocumentOperation } from '@/types/appcontracts/DocumentOperation'
import { DocumentActions } from '@/types/enums/DocumentActions'
import { useRouter } from 'vue-router'
import { Modal } from 'ant-design-vue'

export default defineComponent({
  name: 'InvoiceView',
  components: {
    InvoicePrintPage,
    EditOutlined,
    MailOutlined,
    ShareAltOutlined,
    BellOutlined,
    FilePdfOutlined,
    DollarOutlined,
    EllipsisOutlined,
  },
  props: {
    invoiceAppDoc: {
      type: Object as PropType<IAppDocument<InvoicesDocument> | null>,
      required: true,
    },
  },
  emits: ['invoiceDeleted'],
  setup(props, { emit }) {
    const store = useStore()
    const isLoading = ref<Boolean>(false)
    const router = useRouter()
    const invoiceDocData = computed(() => props.invoiceAppDoc?.doc || null)
    const isStatusMenuDisabled = (menuStatus: InvoiceStatusTypes) => {
      const validMoves = {
        [InvoiceStatusTypes.Draft.toString()]: [InvoiceStatusTypes.Sent, InvoiceStatusTypes.Void],
        [InvoiceStatusTypes.Sent.toString()]: [InvoiceStatusTypes.Paid, InvoiceStatusTypes.Void],
        [InvoiceStatusTypes.Overdue.toString()]: [InvoiceStatusTypes.Paid, InvoiceStatusTypes.Void],
        [InvoiceStatusTypes.Paid.toString()]: [InvoiceStatusTypes.Sent],
        [InvoiceStatusTypes.Void.toString()]: [InvoiceStatusTypes.Draft],
      }
      const prev = invoiceDocData.value?.invoiceStatus
      const curr = menuStatus || null
      if (prev) {
        const moves = validMoves[prev]
        if (moves.indexOf(curr) >= 0) {
          return false
        }
      }
      return true
    }

    const handleStatusMenuClick = async ({ key }: any) => {
      isLoading.value = true
      const docOperation: DocumentOperation<InvoicesDocument | null> = {
        action: DocumentActions.UPDATE,
        id: props.invoiceAppDoc?.id || '',
        payload: { ...(invoiceDocData.value || {}) } as InvoicesDocument,
        audit: invoiceDocData.value?.audit,
      }
      await store.dispatch(`invoices/${actions.InvoicesAction.UPDATE_INVOICE_STATUS}`, {
        status: key,
        docOperation,
      })
      isLoading.value = false
    }

    const handleInvoiceDelete = async () => {
      Modal.confirm({
        title: 'Are you sure you want to delete the invoice ?',
        content: 'This operation cannot be reverted back.',
        icon: createVNode(ExclamationCircleOutlined),
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: async () => {
          isLoading.value = true
          const docOperation: DocumentOperation<InvoicesDocument | null> = {
            action: DocumentActions.DELETE,
            id: props.invoiceAppDoc?.id || '',
            payload: null,
            audit: invoiceDocData.value?.audit,
          }
          await store.dispatch(`invoices/${actions.InvoicesAction.DELETE_INVOICE}`, docOperation)
          isLoading.value = false
          router.push({ name: 'invoices' })
          emit('invoiceDeleted')
        },
        onCancel() {},
      })
    }

    return {
      invoiceDocData,
      isStatusMenuDisabled,
      InvoiceStatusTypes,
      handleStatusMenuClick,
      isLoading,
      handleInvoiceDelete,
    }
  },
})
